// extracted by mini-css-extract-plugin
export var container = "_5v-1";
export var cornerButtonContainer = "_5v-5";
export var disabled = "_5v-2";
export var fileContainer = "_5v-4";
export var hiddenInput = "_5v-3";
export var widthContainer = "_5v-0";